import React from "react";
import { useInView } from "react-intersection-observer";
import "animate.css";

// เพิ่ม / ลบ / สลับลำดับลูกค้า แก้ที่ลิสต์นี้ที่เดียว
// file = ชื่อไฟล์ใน public/clients/  |  w, h = ขนาดจริงของไฟล์ (ใช้คำนวณขนาดที่แสดง)
const clients = [
  {
    file: "royal-thai-police.png",
    th: "สำนักงานตำรวจแห่งชาติ",
    en: "Royal Thai Police",
    w: 228,
    h: 226,
  },
  {
    file: "rtp-narcotics-suppression-bureau.png",
    th: "กองบัญชาการตำรวจปราบปรามยาเสพติด (บช.ปส.)",
    en: "Narcotics Suppression Bureau, Royal Thai Police",
    w: 195,
    h: 217,
  },
  {
    file: "rtp-office-of-inspector-general.png",
    th: "สำนักงานจเรตำรวจ",
    en: "Office of Inspector General, Royal Thai Police",
    w: 227,
    h: 230,
  },
  {
    file: "national-defence-studies-institute.png",
    th: "สถาบันวิชาการป้องกันประเทศ",
    en: "National Defence Studies Institute",
    w: 161,
    h: 249,
  },
  {
    file: "rmut-srivijaya.png",
    th: "มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย",
    en: "Rajamangala University of Technology Srivijaya",
    w: 143,
    h: 250,
  },
  {
    file: "mtts.jpg",
    th: "โรงเรียนช่างฝีมือทหาร",
    en: "Military Technical Training School",
    w: 800,
    h: 600,
  },
  {
    file: "landtransport.jpg",
    th: "กรมการขนส่งทางบก",
    en: "Department of Land Transport",
    w: 250,
    h: 251,
  },
  {
    file: "pdpc.png",
    th: "สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.)",
    en: "Personal Data Protection Committee (PDPC)",
    w: 279,
    h: 157,
  },
  {
    file: "echo-games-thailand.png",
    th: "เอคโค่ เกมส์",
    en: "Echo Games Thailand",
    w: 196,
    h: 192,
  },
  {
    file: "cyber.jpg",
    th: "กองบัญชาการตำรวจสืบสวนสอบสวนอาชญากรรมทางเทคโนโลยี (บช.สอท.)",
    en: "Cyber Crime Investigation Bureau, Royal Thai Police",
    w: 500,
    h: 500,
  },
  {
    file: "mahidol-university.png",
    th: "มหาวิทยาลัยมหิดล",
    en: "Mahidol University",
    w: 182,
    h: 182,
  },
  {
    file: "ejan.jpg",
    th: "อีจัน",
    en: "E-Jan",
    w: 900,
    h: 900,
    // ไฟล์นี้พื้นหลังดำทึบเต็มกรอบ ถ้าไม่มนมุมจะเป็นสี่เหลี่ยมดำโดดจากตัวอื่น
    tile: true,
  },
  {
    file: "dia.jpg",
    th: "สมาคมโรคเบาหวานแห่งประเทศไทย",
    en: "Diabetes Association of Thailand",
    w: 532,
    h: 375,
  },
  {
    file: "raipoong-network-rcpt.png",
    th: "เครือข่ายคนไทยไร้พุง ราชวิทยาลัยอายุรแพทย์แห่งประเทศไทย",
    en: "Thai Raipoong Network, The Royal College of Physicians of Thailand",
    w: 521,
    h: 124,
  },
  {
    file: "RPCA.jpg",
    th: "โรงเรียนนายร้อยตำรวจ",
    en: "Royal Police Cadet Academy",
    w: 800,
    h: 707,
  },
  {
    file: "instituteofinvest.jpg",
    th: "สถาบันส่งเสริมงานสอบสวน",
    en: "Institute of Investigation and Interrogation Affairs",
    w: 1271,
    h: 1288,
  },
  {
    file: "mhesi.jpg",
    th: "กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม",
    en: "Ministry of Higher Education, Science, Research and Innovation",
    w: 250,
    h: 250,
  },
];

// โลโก้แต่ละตัวสัดส่วนไม่เท่ากัน ถ้าบังคับความสูงเท่ากันหมด
// ตัวที่กว้าง (เช่น คนไทยไร้พุง) จะดูใหญ่เกิน ตัวที่สูงจะดูเล็กเกิน
// จึงคิดความสูงจากพื้นที่ให้ทุกตัวมี "น้ำหนักสายตา" ใกล้เคียงกัน
const BASE = 100; // ปรับตัวเลขนี้ตัวเดียวเพื่อขยาย/ย่อโลโก้ทั้งแถว
const MIN_H = 48;
const MAX_H = 116;

const heightOf = ({ w, h }) =>
  Math.min(MAX_H, Math.max(MIN_H, Math.round(BASE / Math.sqrt(w / h))));

// บนจอมือถือ ล็อกความกว้างแต่ละโลโก้ไว้ที่ 1/3 ของแถว จะได้แถวละ 3 ตัวพอดี
// ตัวเลขพอดีเป๊ะคือ 33.333% - 0.834rem (= หัก gap-x-5 สองช่องแล้วหารสาม) แต่เหลือที่ว่าง
// ท้ายแถวแค่ 0.06px การปัดเศษระดับ sub-pixel เลยทำให้บางแถวตกเหลือ 2 ตัว
// จึงหักเผื่อเป็น 1rem ให้มี slack ~8px โลโก้เล็กลงไม่ถึง 3px แต่ได้ 3 ตัวทุกแถวแน่นอน
// sm:min-w-0 จำเป็น: flex item มี min-width:auto ซึ่งสำหรับ <img> คือความกว้างที่แปลงมาจาก
// ความสูง x สัดส่วน โลโก้แนวนอนมาก ๆ (คนไทยไร้พุง อัตราส่วน 4.2) จึงดันตัวเองกว้าง 148px
// ไม่ยอมย่อตาม basis ทำให้แถวนั้นเหลือ 2 ตัว
// จออื่นปล่อยให้กว้างตามสัดส่วนจริง แล้วให้ flex-wrap จัดแถวเอง
const MOBILE_THIRD =
  "sm:w-[calc(33.333%_-_1rem)] sm:basis-[calc(33.333%_-_1rem)] sm:min-w-0 sm:max-w-none sm:grow-0 sm:shrink-0";

function Ourclients({ data }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div ref={inViewRef} className="w-full py-16 sm:py-8">
      <div
        className={`flex sm:px-4 flex-col items-center justify-center ${inView
          ? "animate__animated animate__fadeInLeft animate__slow"
          : "opacity-0 translate-y-10"
          }`}
      >
        <span className="titlecontent">
          {data && data.ClientsSection && data.ClientsSection.title}
          <span className="text-warning">.</span>
        </span>
      </div>
      <div
        className={`flex flex-col items-center justify-center ${inView
          ? "animate__animated animate__fadeInLeft animate__slow"
          : "opacity-0 translate-y-10"
          }`}
      >
        <div className="subcontenttitle px-4 text-center">
          {data && data.ClientsSection && data.ClientsSection.subcontent}
        </div>
      </div>
      <div
        className={`flex w-full justify-center items-center sm:px-4 pt-3 ${inView
          ? "animate__animated animate__fadeInUp animate__slow"
          : "opacity-0 translate-y-10"
          }`}
      >
        <div className="w-full max-w-[1200px] bg-white ring-1 ring-black/5 shadow-[0_12px_32px_rgba(48,60,70,0.06)] rounded-[56px] sm:rounded-3xl px-8 sm:px-4 py-10 sm:py-6">
          {/* flex-wrap ไม่ใช่ grid: แถวสุดท้ายจัดกึ่งกลางเสมอ เพิ่ม/ลบโลโก้กี่ตัว
              ก็ไม่มีตัวโดดชิดซ้าย และแต่ละตัวยังคงสัดส่วนจริงของมันไว้ */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-8 sm:gap-x-5 sm:gap-y-7 [--logo-scale:1] lg:[--logo-scale:0.9] md:[--logo-scale:0.8] sm:[--logo-scale:0.72]">
            {clients.map((client) => (
              <img
                key={client.file}
                src={`/clients/${client.file}`}
                alt={client.th}
                title={client.en}
                width={client.w}
                height={client.h}
                loading="lazy"
                style={{
                  height: `calc(${heightOf(client)}px * var(--logo-scale))`,
                }}
                className={`w-auto max-w-full object-contain transition-transform duration-300 hover:scale-110 ${MOBILE_THIRD} ${
                  client.tile ? "rounded-2xl" : ""
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ourclients;
